/** @jsxImportSource @emotion/react */

const Success = () => (
	<div className="payment-success">
		<div className="container">
			<div className="row">
				<div className="col-sm-12">
					<div className="payment-success__content text-center">
						<div className="d-flex align-items-center justify-content-center">
							<i className="fa fa-check text-success mr-3" css={{ fontSize: 30 }} />
							<h1>Thank you!</h1>
						</div>
						<div>
							<p css={{ fontSize: 18 }}>
								Your shipping information has been submitted. You will receive a text message once
								your device has shipped.
							</p>
						</div>
						<div className="payment-success__content__button">
							<button className="btn btn-primary" onClick={() => window.close()}>
								Close
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
)

export default Success
